/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Deduct_When_LabelInputs */

const vi_packaging_material_deduct_when_label = /** @type {(inputs: Packaging_Material_Deduct_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trừ kho khi nào`)
};

/**

* @param {Packaging_Material_Deduct_When_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_deduct_when_label = /** @type {((inputs?: Packaging_Material_Deduct_When_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Deduct_When_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_deduct_when_label(inputs)
});